// This file is auto-generated. Do not edit!

export default [
  {
    id: "0xff608e5881ccba3859006b3c01e377314384c3d661d684c3e8b6354146e62155",
    name: "USD₮0 / PT-syrupUSDC-29JAN2026",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "915000000000000000",
    oracle: "0x3dC44fF9660B22aDBE67Ce0EC2153f2fb40f90e6",
    loanToken: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
    collateralToken: {
      address: "0x1Ef58a7aF39883CC95c59a2c106b726C64c2ECC6",
      symbol: "PT-syrupUSDC-29JAN2026",
    },
  },
  {
    id: "0xfde386e71d4ea4944bf0e427a89ddafbfce693e02e30b3dc20a62e0bb2d78dcf",
    name: "USDC / USDe",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "915000000000000000",
    oracle: "0x090b20E84aFdc699ec045dB1E7851324E496cad6",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x5d3a1Ff2b6BAb83b63cd9AD0787074081a52ef34",
      symbol: "USDe",
    },
  },
  {
    id: "0xfdd26579fbf52fa1f7f47cf765d4d903b4637b98243fadb8fd43ace2bc808261",
    name: "MYRC / WBTC",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0x3C839D31b6BAE1DfEB0C667D0A3878c536ee20B7",
    loanToken: {
      address: "0x3eD03E95DD894235090B3d4A49E0C3239EDcE59e",
      symbol: "MYRC",
    },
    collateralToken: {
      address: "0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f",
      symbol: "WBTC",
    },
  },
  {
    id: "0xfdb8221edcae73f73485d55c30e706906114bc2ff4634870c5c57e8fb83eae6a",
    name: "USDC / K",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "625000000000000000",
    oracle: "0x2964aB84637d4c3CAF0Fd968be1c97D9990de925",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x010700AB046Dd8e92b0e3587842080Df36364ed3",
      symbol: "K",
    },
  },
  {
    id: "0xfc94eddcfda4f240982948c4390045a296a048fcd088a875a8a58c06d92745d5",
    name: "USDC / GVLT",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "625000000000000000",
    oracle: "0x25Dfe65120a1e688cfdd1BC90B2c2c219c222B6b",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xccd0554EbcE9a27034456C0F8d24091AD894BA70",
      symbol: "GVLT",
    },
  },
  {
    id: "0xfa96426d35010588da342240f90edd236aeef10fdf793c11526e4a6ad6a6da01",
    name: "WETH / wstETH",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "965000000000000000",
    oracle: "0x70dCd188B6444fefFb772b1d3273D8f2767556FE",
    loanToken: {
      address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x5979D7b546E38E414F7E9822514be443A4800529",
      symbol: "wstETH",
    },
  },
  {
    id: "0xf9f58d1c709e70ff558aee62037bbbc7db69528de5748ef5d66e65f5c2290509",
    name: "USDC / MYRC",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0xc8022dC7DA0F0b7F947f859f320825A5B0f9E94E",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x3eD03E95DD894235090B3d4A49E0C3239EDcE59e",
      symbol: "MYRC",
    },
  },
  {
    id: "0xf86f3edd6f16cd8211f4d206866dc4ecd41be6211063ac11f8508e1b7112ef40",
    name: "USDC / syrupUSDC",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "915000000000000000",
    oracle: "0x8f30fF3d54e69D4dfD5E99a9937474FaDdf27009",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x41CA7586cC1311807B4605fBB748a3B8862b42b5",
      symbol: "syrupUSDC",
    },
  },
  {
    id: "0xf5d1fd4990336ea3f3f37fcea2ee5bf202c0fbc33b99db6fdafeb5efa867ab35",
    name: "sUSDe / MUX3LP-sUSDe-5",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "625000000000000000",
    oracle: "0xF22F8FC70d41A7083593261f2cc2F22E798BDF37",
    loanToken: {
      address: "0x211Cc4DD073734dA055fbF44a2b4667d5E5fE5d2",
      symbol: "sUSDe",
    },
    collateralToken: {
      address: "0x4aC33D0E24c9b4e51FcDDDd680534755a1d6A514",
      symbol: "MUX3LP-sUSDe-5",
    },
  },
  {
    id: "0xf4ab212f6fcc943e2669cb6307fa4b608b0418ac5255c100e58394822157785c",
    name: "USDC / PT-USDai-20NOV2025",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "915000000000000000",
    oracle: "0xa161cCae4612425733f6528bC746BB462F894435",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x8b4Ca42bB3B1d789859f106222CF7DC5EEd48CCb",
      symbol: "PT-USDai-20NOV2025",
    },
  },
  {
    id: "0xf2197dc937792ef76da6cc63a4067c79019989e9cae82419cc3af011044b0312",
    name: "MYRC / WETH",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0x63243B850E25e6d45BDBe5a7FD970F075a9Df696",
    loanToken: {
      address: "0x3eD03E95DD894235090B3d4A49E0C3239EDcE59e",
      symbol: "MYRC",
    },
    collateralToken: {
      address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
      symbol: "WETH",
    },
  },
  {
    id: "0xf0e972479040472873566457ad1d85d64e8566434deb6dc0f6b9bf93c5869c4c",
    name: "USDC / WETH",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0xC8e4Fa0199437b812a297202D56dD8d9d1a402a8",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
      symbol: "WETH",
    },
  },
  {
    id: "0xef62d07c7e29c3864feb6de8945edd82688a2ea558de5a44dc795ad1eb1d9853",
    name: "USD₮0 / wsrUSD",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "915000000000000000",
    oracle: "0xAB81e18001836C40894D7a55e4706FC7d063E0d4",
    loanToken: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
    collateralToken: {
      address: "0x4809010926aec940b550D34a46A52739f996D75D",
      symbol: "wsrUSD",
    },
  },
  {
    id: "0xed3f9a960d927791a354cc4549b1b44af9dd06c11566ea9d0bff66b8e4969610",
    name: "USDC / XAUt0",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "770000000000000000",
    oracle: "0xA576e986ADD337Ff09a57d7778C477d27ee7bF8b",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x40461291347e1eCbb09499F3371D3f17f10d7159",
      symbol: "XAUt0",
    },
  },
  {
    id: "0xed06d9e82d7c35ca80d3983194e15462a96202bd875800af18183321f4611868",
    name: "USD₮0 / WBTC",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0xEDcAE878827fc68B9bC9c700CA17c20F811b1612",
    loanToken: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
    collateralToken: {
      address: "0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f",
      symbol: "WBTC",
    },
  },
  {
    id: "0xeceb9d187e3fbe4511bfd5db28d7c02c2e569fcae338456ddbf1e6044962073a",
    name: "sUSDe / MUX3LP-sUSDe-7",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "625000000000000000",
    oracle: "0x2dB89368d7c74AE5841B3aC8De24A1dEcbb4ab68",
    loanToken: {
      address: "0x211Cc4DD073734dA055fbF44a2b4667d5E5fE5d2",
      symbol: "sUSDe",
    },
    collateralToken: {
      address: "0xacD3471D77c25E5d98aB4A3f4402999f02cEf2A0",
      symbol: "MUX3LP-sUSDe-7",
    },
  },
  {
    id: "0xeb6678faedf7c8c4868e32520c16d601d0affce59d55ac7b1800f754e12b85f0",
    name: "ARB / USDC",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "945000000000000000",
    oracle: "0xAB70fA36D764fe4c8ceD3d10611259BA9A35FC7D",
    loanToken: {
      address: "0x912CE59144191C1204E64559FE8253a0e49E6548",
      symbol: "ARB",
    },
    collateralToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0xeb22867e462bfe524ce8ca166ca082d2fc693f90eb85f221389d3b1511c42320",
    name: "MYRC / USD₮0",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0xdd8293804c5d91e16728A324F98B338E3E614401",
    loanToken: {
      address: "0x3eD03E95DD894235090B3d4A49E0C3239EDcE59e",
      symbol: "MYRC",
    },
    collateralToken: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
  },
  {
    id: "0xea7a6e401612572217359d6a25a14388e415d7c073ef614d668ef7a33e6610a7",
    name: "USDC / WETH",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0xB6F867Df93550551c2467b25B597BE2979A03C8e",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
      symbol: "WETH",
    },
  },
  {
    id: "0xea35a2aea772f709edd5d14d35697187ba19280852c6d221b7c38e35a09ca670",
    name: "AUSD / WBTC",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0x57aB4A096bF8EAE58df65B9F72E3AfeA7cFCBCaF",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f",
      symbol: "WBTC",
    },
  },
  {
    id: "0xe889de0e5786c061336cf9b4db78f332ae78e44c086d9a1659dd1e031ccce524",
    name: "AUSD / WETH",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0x4b59b322CEDa280A504B4Fc83F89575779BA9bCE",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
      symbol: "WETH",
    },
  },
  {
    id: "0xe6392ff19d10454b099d692b58c361ef93e31af34ed1ef78232e07c78fe99169",
    name: "USDC / WBTC",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0x88193FcB705d29724A40Bb818eCAA47dD5F014d9",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f",
      symbol: "WBTC",
    },
  },
  {
    id: "0xe24e6c39a65c2d0a83b893c0f3e32d77644c96b67593d323e4a38e98c2baf844",
    name: "USDC / sUSDe",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "915000000000000000",
    oracle: "0x67A350a6A0DD3376325E442fFF5fB05E3a06D7F4",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x211Cc4DD073734dA055fbF44a2b4667d5E5fE5d2",
      symbol: "sUSDe",
    },
  },
  {
    id: "0xe23e15ddd552eb148045e3f4b74e71f4923bc6bea6e5bda0a4cf89a0cecd1a3b",
    name: "USDC / siUSD",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "915000000000000000",
    oracle: "0xB283D0c3438D0430F9B414B487F50cfD415EEC0A",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x51B0f6AED4a421f09D28A5eDe1DCF460BCB54d30",
      symbol: "siUSD",
    },
  },
  {
    id: "0xe0de6b571ec913ada63d5327f70c8849ea2363d47f44a190e8fb489db07fee1e",
    name: "USDC / USDe",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "915000000000000000",
    oracle: "0x8A27AEc0b1EbDE3Aa22896b60A16b8fE6e7d4AaD",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x5d3a1Ff2b6BAb83b63cd9AD0787074081a52ef34",
      symbol: "USDe",
    },
  },
  {
    id: "0xe08d47da038986af5e2da1828664aefa96bd303983473d882da64d2607b7632c",
    name: "MYRC / WETH",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0x1E3162EA995249a6377D1D9a70329cAa5a3b15a1",
    loanToken: {
      address: "0x3eD03E95DD894235090B3d4A49E0C3239EDcE59e",
      symbol: "MYRC",
    },
    collateralToken: {
      address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
      symbol: "WETH",
    },
  },
  {
    id: "0xe0432ceb599fbe41defbd62fe8e914824af9d891a0a92c39de7063176c8e480b",
    name: "USD₮0 / weETH",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0xff135c74798c432B3172501a54fd56F85aA60A8A",
    loanToken: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
    collateralToken: {
      address: "0x35751007a407ca6FEFfE80b3cB397736D2cf4dbe",
      symbol: "weETH",
    },
  },
  {
    id: "0xdfa832f89c5c090398b4a7ca1b4f1d3146bd9ef6c68c9b8abe2e3e45fab1acb3",
    name: "WETH / WBTC",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "915000000000000000",
    oracle: "0x3855b7833C7Cb22aDCAB28505D838A2015eA8457",
    loanToken: {
      address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f",
      symbol: "WBTC",
    },
  },
  {
    id: "0xde895fd4a9d1ca693485fcfc2ee47d8c3b47f810bbce3c965c60d97b855d4ed2",
    name: "USD₮0 / sUSDS",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "945000000000000000",
    oracle: "0x061126ba5a62DdF6dfFBA635AAEF64671f5251d7",
    loanToken: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
    collateralToken: {
      address: "0xdDb46999F8891663a8F2828d25298f70416d7610",
      symbol: "sUSDS",
    },
  },
  {
    id: "0xde7f9f3b444b47766e77f571dcc991479bfcb02bc34e1535f3ecdd8471c68ecd",
    name: "MYRC / WETH",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0x643419683c4f24fC71Bc80a73aBcd3657BBfa005",
    loanToken: {
      address: "0x3eD03E95DD894235090B3d4A49E0C3239EDcE59e",
      symbol: "MYRC",
    },
    collateralToken: {
      address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
      symbol: "WETH",
    },
  },
  {
    id: "0xdd7e1e279b340527751fbc8c99d2f8aa803ebdc4f255ed2087140553dc8ed78d",
    name: "USDC / PT-thBILL-19FEB2026",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "945000000000000000",
    oracle: "0x3E0E1e5aef3ea576750AdED57b7Bf3a42161B6Cd",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x9b3924f9652cabf3Db48B7B4C92E474c571B3Ab4",
      symbol: "PT-thBILL-19FEB2026",
    },
  },
  {
    id: "0xdd2d0b25190bd7cb71819ff3d93c9be1efa7af1482955a7322ebac5c067c2cac",
    name: "USDC / PT-USDai-18JUN2026",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "915000000000000000",
    oracle: "0x611c72862063305A4f0106246c3Af85b6520FD3E",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x1cdDE40e29dA213f42A7fA109CcADCA372d9Ee1B",
      symbol: "PT-USDai-18JUN2026",
    },
  },
  {
    id: "0xdc3edb8cdf997ee55ac67d521f0fcb65a75272007abc5157ca1841b10635732e",
    name: "mJPYC / mKGLD",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0x946273Cf499e7fE6f1c4A5810aD693292d773c12",
    loanToken: {
      address: "0xcc7b0546991e25DdA448F8048a1E8e43135cBC39",
      symbol: "mJPYC",
    },
    collateralToken: {
      address: "0x5C275d38A23BBF2e1Bc28B88093Aeb60e49De8Fe",
      symbol: "mKGLD",
    },
  },
  {
    id: "0xdbeea0b7cc09f4a4cf167a4ecc92ee25dcaf38d8c441500416a94b2fe78f6863",
    name: "MYRC / WETH",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0x563E2203297441d5a225475Bb48eB5C135542760",
    loanToken: {
      address: "0x3eD03E95DD894235090B3d4A49E0C3239EDcE59e",
      symbol: "MYRC",
    },
    collateralToken: {
      address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
      symbol: "WETH",
    },
  },
  {
    id: "0xdb493f6e7f7b2ba5bf0cf37bc641c46f087515b82c98034c8d3422c3de00de45",
    name: "USDC / USDai",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "915000000000000000",
    oracle: "0xd029280d2917F24bEab009F39c33b262241a52a8",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x0A1a1A107E45b7Ced86833863f482BC5f4ed82EF",
      symbol: "USDai",
    },
  },
  {
    id: "0xd92b7e0b89e9af24331a66aa1bfa22ff956e2fadafb64fd53b00f4544f2311c3",
    name: "USDC / syrupUSDC",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0xF8722c901675C4F2F7824E256B8A6477b2c105FB",
    loanToken: {
      address: "0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x41CA7586cC1311807B4605fBB748a3B8862b42b5",
      symbol: "syrupUSDC",
    },
  },
  {
    id: "0xd91052003758145cc53615895c0ce2081c7080b661dbab5652c2b8433b248c2d",
    name: "USD₮0 / siUSD",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "915000000000000000",
    oracle: "0x9fcDf72F1585E3D96DdAC6D35CD7087cC58dC589",
    loanToken: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
    collateralToken: {
      address: "0x51B0f6AED4a421f09D28A5eDe1DCF460BCB54d30",
      symbol: "siUSD",
    },
  },
  {
    id: "0xd89e33d037884b9ef12a337f91d9d7bd7fd2d1dcdc909daa2cc8ed164093fb7d",
    name: "USDC / USD₮0",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "965000000000000000",
    oracle: "0x28d60D217E98FeD946A29657013596Fa43e8d485",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
  },
  {
    id: "0xd478de9c069f12759d3baed9ddd16fe8902128937821af3a3cf77eca1885c7fc",
    name: "USDC / rsETH",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "770000000000000000",
    oracle: "0x5F792ba55dB68cc12005388C3d8fb6bD4a3386F8",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4186BFC76E2E237523CBC30FD220FE055156b41F",
      symbol: "rsETH",
    },
  },
  {
    id: "0xd381c328eab711ebdac60f87d708dd9a861da467cf63bc45f537d221d146f86f",
    name: "USDC / FRAX",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0x44a86D7045795125E5dD2B075a7060794D7d8a71",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x17FC002b466eEc40DaE837Fc4bE5c67993ddBd6F",
      symbol: "FRAX",
    },
  },
  {
    id: "0xd341a054fba45e090825685e3c1dbcada736360895fdb27f179799cd809cdbc3",
    name: "USDC / WETH",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0x25b09895604d22E960e39Cd2fBEABd01D932E4a8",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
      symbol: "WETH",
    },
  },
  {
    id: "0xd09404e9512e1341321c8ae3bd663fab7087582142ac61486635a6c072c2af12",
    name: "USDC / weETH",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0x4E49d73434a78866d217BE0B542CA868495CBc77",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x35751007a407ca6FEFfE80b3cB397736D2cf4dbe",
      symbol: "weETH",
    },
  },
  {
    id: "0xcf4c7cf2b2a4521d33e4ae1df6f31d5d17341244ad65f35984a8622edec250a0",
    name: "USDC / PT-sUSDai-19FEB2026",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0x3707F4400F8bB68E81672815E92aca13255Feb75",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x1BF1311FCF914A69Dd5805C9B06b72F80539cB3f",
      symbol: "PT-sUSDai-19FEB2026",
    },
  },
  {
    id: "0xcd3fea5a0d49c4948d32fdee2406548073aac25dba5cab6ed160d50363f3d094",
    name: "USDC / wsrUSD",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "915000000000000000",
    oracle: "0x52deA1E79273887Ad0bdF3FaF3904351Ae9460e0",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4809010926aec940b550D34a46A52739f996D75D",
      symbol: "wsrUSD",
    },
  },
  {
    id: "0xcce2e714c3c82d3aa838112dc3802a73c3c47ce3ade7e0fb9bc08e0636814529",
    name: "sUSDe / MUX3LP-sUSDe-1",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "625000000000000000",
    oracle: "0x9Fe9c01E03336d7f53b1F5CC2D94dcc0155BddB6",
    loanToken: {
      address: "0x211Cc4DD073734dA055fbF44a2b4667d5E5fE5d2",
      symbol: "sUSDe",
    },
    collateralToken: {
      address: "0xA1082BDFC6f21cD71073FFeE2823139D67878aaE",
      symbol: "MUX3LP-sUSDe-1",
    },
  },
  {
    id: "0xccc686b651cfedfbfc5e92b6a1953fc1c738e360634a48394f2ba7a704ac3cec",
    name: "WETH / weETH",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "945000000000000000",
    oracle: "0xF287a5725E9e78B55cA3aEd614ce9bD8Ea6d5583",
    loanToken: {
      address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x35751007a407ca6FEFfE80b3cB397736D2cf4dbe",
      symbol: "weETH",
    },
  },
  {
    id: "0xcc4c47b13b025dff3a78de61b179bdab730abcda5aa3cf6cbbe00e97a51c7626",
    name: "sUSDe / MUX3LP-sUSDe-2",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "625000000000000000",
    oracle: "0xdeefD89D9a4F65e50F470b6592989D5154b3fF7f",
    loanToken: {
      address: "0x211Cc4DD073734dA055fbF44a2b4667d5E5fE5d2",
      symbol: "sUSDe",
    },
    collateralToken: {
      address: "0xd85D0bCE8Ff396EA1198996a21f96Db2feB8e943",
      symbol: "MUX3LP-sUSDe-2",
    },
  },
  {
    id: "0xca83d02be579485cc10945c9597a6141e772f1cf0e0aa28d09a327b6cbd8642c",
    name: "USDC / WETH",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0x282FEB10549fde52bD61A6979424Ddf18A4971A2",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
      symbol: "WETH",
    },
  },
  {
    id: "0xc9742647fcbf5bb1eeb22aea89fae407a9e09fae7c2e485b6d34a727eb0b8e82",
    name: "AUSD / WETH",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0xEE7564DA3A3CCc580805cD05DB1c7f3529d9faA8",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
      symbol: "WETH",
    },
  },
  {
    id: "0xc87de8c389093534c3e23852c01b74c305f86ce4db9348554434f9a2b74e436a",
    name: "USD₮0 / wstETH",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0x8e02a9b9Cc29d783b2fCB71C3a72651B591cae31",
    loanToken: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
    collateralToken: {
      address: "0x5979D7b546E38E414F7E9822514be443A4800529",
      symbol: "wstETH",
    },
  },
  {
    id: "0xc8455ed78482f7ef016caf0127c7ffd5e643b3b83d08d43e242a63c12358f754",
    name: "USDC / PT-thBILL-18JUN2026",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "915000000000000000",
    oracle: "0xdDc762cC71B5CD6D93A4E75df97834070d255d76",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xE46271ecb1d5c7c5134868760F10c18B03021eF1",
      symbol: "PT-thBILL-18JUN2026",
    },
  },
  {
    id: "0xc7670063349ac19dfa324ead7bd7da2985ae931e1b09fb0e31b62c6486b730bd",
    name: "USDC / RLP",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0x2d8380D2E2DBE516049fA2c4CB2EC48C418d249C",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x35E5dB674D8e93a03d814FA0ADa70731efe8a4b9",
      symbol: "RLP",
    },
  },
  {
    id: "0xc7558303264f540f3e1d0a3ef2c40362503e4da8877c41366721d533dadf02a7",
    name: "USDC / PT-USDai-18JUN2026",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "915000000000000000",
    oracle: "0x5118e65f52327a72708e092b4722C1a9ee48CFe6",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x1cdDE40e29dA213f42A7fA109CcADCA372d9Ee1B",
      symbol: "PT-USDai-18JUN2026",
    },
  },
  {
    id: "0xc5aab7c25d946ac22853a6d31d3da0a5f69c7b06548a1fb7bee3b4182def777c",
    name: "USDC / PT-sUSDai-20NOV2025",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0xe8cF0F43D25A165cf8b862f1088e0C26E4DC0f41",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x936F210d277bf489A3211CeF9AB4BC47a7B69C96",
      symbol: "PT-sUSDai-20NOV2025",
    },
  },
  {
    id: "0xc563902194cc081244aa5e6ea67d8283d2d121b106e73a4af2ae9fa5941add96",
    name: "BOLt / USD₮0",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "770000000000000000",
    oracle: "0xd2Cf6C80Fbd8868900b2BcB131ae69B0879797AC",
    loanToken: {
      address: "0x1edF5E61B6a4Fe19FEf3A695328F61aAa07728eA",
      symbol: "BOLt",
    },
    collateralToken: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
  },
  {
    id: "0xc3cf622f10bca0fbc0d133a4a30e4be9dedf24ff2f5194e17fdc52aace71f218",
    name: "USDC / MYRC",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0xae8421C50356A0BBfD7FF275A78576f65506B0Fe",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x3eD03E95DD894235090B3d4A49E0C3239EDcE59e",
      symbol: "MYRC",
    },
  },
  {
    id: "0xc35065b88295b2f06b5fa19a9c318dee5e249bae31e3c3de6a66cbd5b38eca84",
    name: "USDC / PT-mHYPER-20NOV2025",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "915000000000000000",
    oracle: "0xFb6B8346Cb05Dc75433516858A446Da119cDc9c6",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x9d2ce39C0bF9BAA959CB65163FBcA89B91D240C5",
      symbol: "PT-mHYPER-20NOV2025",
    },
  },
  {
    id: "0xc2b0c8a40fd3c0013b47cc9e62d7a1b5ed75859005d37a8803f8c554f9872a4c",
    name: "USD₮0 / WETH",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0x71479022D31069A62C3C04c9486221C41ef5B4Ba",
    loanToken: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
    collateralToken: {
      address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
      symbol: "WETH",
    },
  },
  {
    id: "0xc296b34c21ad74e879906bfa20b6351e1a489cc1d2c50ebf491253e39b60daa6",
    name: "sUSDe / MUX3LP-sUSDe-3",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "625000000000000000",
    oracle: "0x37DAa236B4dF1eae75A14f01457FEa42ED150d9b",
    loanToken: {
      address: "0x211Cc4DD073734dA055fbF44a2b4667d5E5fE5d2",
      symbol: "sUSDe",
    },
    collateralToken: {
      address: "0xAb0910755D99b420c51f48B6847733bB3fe19Af4",
      symbol: "MUX3LP-sUSDe-3",
    },
  },
  {
    id: "0xc089c41a74f0e53378b4edd4a1f91842edceae5571df8a423a59052e8c0c7fb7",
    name: "USD₮0 / sUSDe",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "915000000000000000",
    oracle: "0x7Cce11A901A684dD6017f527D4ffe82d73d626DB",
    loanToken: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
    collateralToken: {
      address: "0x211Cc4DD073734dA055fbF44a2b4667d5E5fE5d2",
      symbol: "sUSDe",
    },
  },
  {
    id: "0xc05f23c01ac95c0b5d089113e9a3bbc14190fa8e2782c42bb7d5a7402f703e98",
    name: "USDC / ARB",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "945000000000000000",
    oracle: "0x188Bbb31175c64662e8CFcef648b75ad64b1452c",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x912CE59144191C1204E64559FE8253a0e49E6548",
      symbol: "ARB",
    },
  },
  {
    id: "0xbe0f7ce619e4faeeae2cfecfcc5cceae6ce656537da40ef400ae94139272412d",
    name: "USDC / TART",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "625000000000000000",
    oracle: "0x640Fc1a44Ed4E0ed681969103BB793A18c22770E",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xD1aB66a665B887d5507A457D957151CB36E4f0F2",
      symbol: "TART",
    },
  },
  {
    id: "0xbd0a07e2f6a2348577610d04039a2327f4e84b98b2255665ece4c927259a50f4",
    name: "USDC / vyUSD",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "915000000000000000",
    oracle: "0xff49951dbcf6Db2d15fea10735FD4E09a5798C08",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xF4F447E6AFa04c9D11Ef0e2fC0d7f19C24Ee55de",
      symbol: "vyUSD",
    },
  },
  {
    id: "0xbc6b44997d22ee3f5f0dc5860eeb806b6c289468d056dca40edee8877c02aa9e",
    name: "sUSDC / MUX3LP-sUSDC-1",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "625000000000000000",
    oracle: "0x1168e7bE6C5Aa56dFB757451fBc7Dc11020bFc68",
    loanToken: {
      address: "0x940098b108fB7D0a7E374f6eDED7760787464609",
      symbol: "sUSDC",
    },
    collateralToken: {
      address: "0x5513FD8d55133ECc0f5fF0bF768c100528132630",
      symbol: "MUX3LP-sUSDC-1",
    },
  },
  {
    id: "0xbc24028b9a91ada7a0cd72e3bfed98d468985098bf056c71afcd3c4280b7f7d7",
    name: "USDC / vyUSD",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "915000000000000000",
    oracle: "0x3cDDcC55B66487FA23db41d1864dACA0dD07aE6F",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xF4F447E6AFa04c9D11Ef0e2fC0d7f19C24Ee55de",
      symbol: "vyUSD",
    },
  },
  {
    id: "0xbb1200e0bc8ea1ebab1fbc54358e99e73ca66e12cba797268c5e4d9461be3ca0",
    name: "sUSDe / MUX3LP-sUSDe-6",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "625000000000000000",
    oracle: "0x3396664aB74685D0dCE4183C8C11D05Dbe3EaA0d",
    loanToken: {
      address: "0x211Cc4DD073734dA055fbF44a2b4667d5E5fE5d2",
      symbol: "sUSDe",
    },
    collateralToken: {
      address: "0xC432B2A5100C99ef12161Be5237B3a5Cfc3E8377",
      symbol: "MUX3LP-sUSDe-6",
    },
  },
  {
    id: "0xb8f554ee76dfa3c2f2eab8127d48e6fcb8713a66c622835e0a74ac5a5aced29e",
    name: "unknown / MUX3LP-sUSDC-2",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "625000000000000000",
    oracle: "0xf961556026431E9704d179fC3e49a1c10751299d",
    loanToken: {
      address: "0xf8B3Fa720a9Cd8ABeeD5A81f11F80cD8f93E6B57",
      symbol: "unknown",
    },
    collateralToken: {
      address: "0x651B884f22FDA21090eF5326d8F78BD6DC9D2D65",
      symbol: "MUX3LP-sUSDC-2",
    },
  },
  {
    id: "0xb88b6694b5ff19d1b09168a64c3c25b2c888440bb6ea756e4aab10f2aa0b5194",
    name: "USDC / stUSD",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "965000000000000000",
    oracle: "0x527Df15e68fA2c2da381aA3536F1AC99ad4cbC18",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x0022228a2cc5E7eF0274A7Baa600d44da5aB5776",
      symbol: "stUSD",
    },
  },
  {
    id: "0xb7b5729ad332f57a02f4d9f87aa50910ee955d859e2b2ad9b0b8e15ca44d8b7f",
    name: "USDC / ezETH",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "770000000000000000",
    oracle: "0x2cf21D17DaD427d185B0221D01FD31ea117c7cfa",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x2416092f143378750bb29b79eD961ab195CcEea5",
      symbol: "ezETH",
    },
  },
  {
    id: "0xb4da08bd39f6f562662bf982bbb423b578b0f1a5e4329ad9173afa176a3c1017",
    name: "USDC / bbqUSDT0",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "965000000000000000",
    oracle: "0xF52f3a60357CcA74a5fEF1D2E0D108153911328B",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4739E2c293bDCD835829aA7c5d7fBdee93565D1a",
      symbol: "bbqUSDT0",
    },
  },
  {
    id: "0xb36f4bc24d26b574133222f69b9bfb051ba4ee1dadb40be048f9f6eff120ac0a",
    name: "mUSDT / mKGLD",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0xbaf671e0a97E1e43c07A02Bf7351eb876756dF28",
    loanToken: {
      address: "0xFDfC5fA3f087700b7c9D246c871BFdE25350508d",
      symbol: "mUSDT",
    },
    collateralToken: {
      address: "0x00e90a3633023392d9794Fe305bcC48BE90c0b69",
      symbol: "mKGLD",
    },
  },
  {
    id: "0xaf642e81aef72331fd70e423e0966c1d91e6364abab239966066da893a20457f",
    name: "MYRC / USDC",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0x3Ea1EC9Ae1f3b01d5415257F378638128346a39d",
    loanToken: {
      address: "0x3eD03E95DD894235090B3d4A49E0C3239EDcE59e",
      symbol: "MYRC",
    },
    collateralToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0xaed7457373d6df7479868c9fa566dddf7ee25ff8757a76e60cda2cd5508947a7",
    name: "BOLt / USD₮0",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "770000000000000000",
    oracle: "0x5Eaa8760c3290eb78A2BE5E33b6696bE42e47DD9",
    loanToken: {
      address: "0x1edF5E61B6a4Fe19FEf3A695328F61aAa07728eA",
      symbol: "BOLt",
    },
    collateralToken: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
  },
  {
    id: "0xadc6897d644a005149d1aa42de72bcb1ff1c9f7c4a8b00db3e2356752995f80e",
    name: "USD₮0 / wstUSR",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "915000000000000000",
    oracle: "0xd21531b0061F70291e698Cf976fb8604afc689C0",
    loanToken: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
    collateralToken: {
      address: "0x66CFbD79257dC5217903A36293120282548E2254",
      symbol: "wstUSR",
    },
  },
  {
    id: "0xac9c657dcbc1fce3adbd69d120ebe3a5ba99825a25db25cb3d96321309b745c5",
    name: "sUSDe / MUX3LP-sUSDe-7",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "625000000000000000",
    oracle: "0x82aE09282E1b508d35bb6D735bb915C9f22708f0",
    loanToken: {
      address: "0x211Cc4DD073734dA055fbF44a2b4667d5E5fE5d2",
      symbol: "sUSDe",
    },
    collateralToken: {
      address: "0xacD3471D77c25E5d98aB4A3f4402999f02cEf2A0",
      symbol: "MUX3LP-sUSDe-7",
    },
  },
  {
    id: "0xac6a118134cc4208a22534b041a83f4ac5ca42e2ab9ea732ee53c44b7deebc62",
    name: "USD₮0 / WETH",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0x282FEB10549fde52bD61A6979424Ddf18A4971A2",
    loanToken: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
    collateralToken: {
      address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
      symbol: "WETH",
    },
  },
  {
    id: "0xac3f3c157e64ec62c497615891a35b901cd5ecfdd32cff28febda2e3fec19c07",
    name: "mUSDS / mHOME",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "0",
    oracle: "0xB61B471aB1fDce6b3c234e2b50555A455819fEC6",
    loanToken: {
      address: "0x5040583F5481C928d45B16108d2C6eB14Fa98e66",
      symbol: "mUSDS",
    },
    collateralToken: {
      address: "0xd418b157F93854E84f0d6BA7B1AaE5740A295eB9",
      symbol: "mHOME",
    },
  },
  {
    id: "0xa86c78f14b3261cec38e746fd2f3eb0ddb2b3ffbb3439d42d262158de3baf4e4",
    name: "USD₮0 / MYRC",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0xccD9a1df5A2303c783DD3Ab28960b29929BFaBe7",
    loanToken: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
    collateralToken: {
      address: "0x3eD03E95DD894235090B3d4A49E0C3239EDcE59e",
      symbol: "MYRC",
    },
  },
  {
    id: "0xa46d32d4f61adbbcfe5827bdd66548c8660fbb2f170705184ce517a15aff8537",
    name: "WETH / WBTC",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "625000000000000000",
    oracle: "0x16fd4509BeDe2Bd3ab3cA433c1ae8064B01Ec3dF",
    loanToken: {
      address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f",
      symbol: "WBTC",
    },
  },
  {
    id: "0xa35d91efb3e284a0ab7098e8c5a65caf58ea0451073e36a544a821fd8f350953",
    name: "USDC / GLV [WBTC-USDC]",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "770000000000000000",
    oracle: "0xC3e8216E62850CEd43Ff5b5b1ead85CB1B579b4F",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xdF03EEd325b82bC1d4Db8b49c30ecc9E05104b96",
      symbol: "GLV [WBTC-USDC]",
    },
  },
  {
    id: "0xa3096238206514b65d7d90eb8739595188c88a3483d1a47664ff71aec3a04852",
    name: "USDC / USDe",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "945000000000000000",
    oracle: "0xAB70fA36D764fe4c8ceD3d10611259BA9A35FC7D",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x5d3a1Ff2b6BAb83b63cd9AD0787074081a52ef34",
      symbol: "USDe",
    },
  },
  {
    id: "0xa032fafeeb5b8143ede3ae234450f75d69245f4f73e4104cfabc251e3a869aab",
    name: "MYRC / USD₮0",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0xeF77CcD2E662C3b06f3f5d878d11a8c64816f715",
    loanToken: {
      address: "0x3eD03E95DD894235090B3d4A49E0C3239EDcE59e",
      symbol: "MYRC",
    },
    collateralToken: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
  },
  {
    id: "0x9f486476783622a711011879535e136fa9d2b4f503ae390f458c6e970c07d5ed",
    name: "USDC / yUSD",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "915000000000000000",
    oracle: "0xFa179A5648E83cc17aa53245a1e3A10543Dd163d",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4772D2e014F9fC3a820C444e3313968e9a5C8121",
      symbol: "yUSD",
    },
  },
  {
    id: "0x9e90aec7d768403dacc9dd0d8320307fda3f980eed4df43e3e52168a1c667709",
    name: "USDC / xUSD",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "915000000000000000",
    oracle: "0x1837efFC34Bb5a96EFdA00d53560799bE3a4226E",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x6eAf19b2FC24552925dB245F9Ff613157a7dbb4C",
      symbol: "xUSD",
    },
  },
  {
    id: "0x9e00fc26d56080286b0e5656c67a45f1871a810bd8e3838ad4ff7372014bed80",
    name: "mUSDT / TGT",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0x7158cd65011CF70aBFC55dc723b91a4DDb713953",
    loanToken: {
      address: "0x69E23AA75911f6693E89307bBdB9B0Fe476FbA50",
      symbol: "mUSDT",
    },
    collateralToken: {
      address: "0xB5aB426730b8b60E90e5c41E544DF978107cb6C0",
      symbol: "TGT",
    },
  },
  {
    id: "0x9b1c003e526a51491480854a6ae79f6e66f6a5d6cc9d77cdd0976127af822089",
    name: "WETH / rsETH",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "945000000000000000",
    oracle: "0xAC55d7601C7108A9CFE3D1E0224984204089154F",
    loanToken: {
      address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x4186BFC76E2E237523CBC30FD220FE055156b41F",
      symbol: "rsETH",
    },
  },
  {
    id: "0x99115cd86d78bf823c0d4bc60fcd512436e44ea15e4dd025e531ed0941153578",
    name: "USDC / TART",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "625000000000000000",
    oracle: "0x1F052C4e8370Ee599B2267aCb4D6e268672a9527",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x2B1D0BaD12Eb981D9d3c304cB623Fd211Cf84651",
      symbol: "TART",
    },
  },
  {
    id: "0x98a937249ffe404bd46215ed94fba4a8be508a02fbf5a0a710e6e649795f7851",
    name: "WETH / wstETH",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "945000000000000000",
    oracle: "0x9041D09213607A0E85190719e60d11125583612D",
    loanToken: {
      address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x5979D7b546E38E414F7E9822514be443A4800529",
      symbol: "wstETH",
    },
  },
  {
    id: "0x989ddb4f5b09e6d02e7f5f2f8efb846fd2de1f3f3dfd96e1939455abe7dd5a48",
    name: "USDC / sUSDC",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "915000000000000000",
    oracle: "0x0EDAa484b877c96F609931a63d78f3d55BCeB864",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x940098b108fB7D0a7E374f6eDED7760787464609",
      symbol: "sUSDC",
    },
  },
  {
    id: "0x98225f86d3c0673d9b652b12f021f9bc6a09c9ca960680bea23c4de7e2a90f64",
    name: "USD₮0 / PT-USDai-18JUN2026",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "915000000000000000",
    oracle: "0x2252b2910f2A584C66E6215f31DBEDcC37b32AA9",
    loanToken: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
    collateralToken: {
      address: "0x1cdDE40e29dA213f42A7fA109CcADCA372d9Ee1B",
      symbol: "PT-USDai-18JUN2026",
    },
  },
  {
    id: "0x958b40fcd0df023c156ec4a7eb8ffd47985b19d8bb02a36fb0af1bfc837fd605",
    name: "USDC / PT-USDai-18JUN2026",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "915000000000000000",
    oracle: "0x2252b2910f2A584C66E6215f31DBEDcC37b32AA9",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x1cdDE40e29dA213f42A7fA109CcADCA372d9Ee1B",
      symbol: "PT-USDai-18JUN2026",
    },
  },
  {
    id: "0x941f407149a7365a76829bdc1e47c88b528efdc06d34e8a4cb363462e51167d8",
    name: "USD₮0 / bbqUSDC",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "965000000000000000",
    oracle: "0x621749954e4a1a06FBe040F32873cb0d035f909A",
    loanToken: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
    collateralToken: {
      address: "0xbeeff1D5dE8F79ff37a151681100B039661da518",
      symbol: "bbqUSDC",
    },
  },
  {
    id: "0x912dfca6cc5c7097ab9229ea4e631c9a5fe7aca15be8ef3f594f7674413f4c32",
    name: "USDC / PT-sUSDai-19FEB2026",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0x97576e5e8aFb600Fd35717Db0DEcD6B4A9277e30",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x1BF1311FCF914A69Dd5805C9B06b72F80539cB3f",
      symbol: "PT-sUSDai-19FEB2026",
    },
  },
  {
    id: "0x90a63331978485224d2c69a8e658902bb65a3c81ca12eaf1c8d10f4251013b30",
    name: "USD₮0 / USDe",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "915000000000000000",
    oracle: "0x875800C9b5F42F2f7afcb6771c9005C105da6cA5",
    loanToken: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
    collateralToken: {
      address: "0x5d3a1Ff2b6BAb83b63cd9AD0787074081a52ef34",
      symbol: "USDe",
    },
  },
  {
    id: "0x8e58f0dea27f877db258ecbbe16e57c9bb3541448ac0d578ef08c5b93ea9b84b",
    name: "USD₮0 / sUSDe",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "915000000000000000",
    oracle: "0x2651f4f4d506848E645b52138B7b9583257c4B18",
    loanToken: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
    collateralToken: {
      address: "0x211Cc4DD073734dA055fbF44a2b4667d5E5fE5d2",
      symbol: "sUSDe",
    },
  },
  {
    id: "0x864550da00a2d24803cb9e4d791584d4e4b6523de866ed7b4608348a1b8c161d",
    name: "USD₮0 / sUSDS",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "945000000000000000",
    oracle: "0x43fc0B5B74A107f1AE1AFdA72158bEC56b082522",
    loanToken: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
    collateralToken: {
      address: "0xdDb46999F8891663a8F2828d25298f70416d7610",
      symbol: "sUSDS",
    },
  },
  {
    id: "0x859e2cab824e8a459b5d07778be96d0abacdcfbcb90fad46e53c4f4d60941e94",
    name: "sUSDe / MUX3LP-sUSDe-8",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "625000000000000000",
    oracle: "0x594DFD70F133d60c47728CfAA0be1Ec31853a747",
    loanToken: {
      address: "0x211Cc4DD073734dA055fbF44a2b4667d5E5fE5d2",
      symbol: "sUSDe",
    },
    collateralToken: {
      address: "0x87f980bb419365DF5E665C8Af0a3996BE154873a",
      symbol: "MUX3LP-sUSDe-8",
    },
  },
  {
    id: "0x84367e5bc5df26437618f749d5beb793746e620560721fec15518d684191ebc6",
    name: "USDC / PT-syrupUSDC-29JAN2026",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "915000000000000000",
    oracle: "0x461520438Fb5eD1C3D4809963CaAe4c5f38Db26D",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x1Ef58a7aF39883CC95c59a2c106b726C64c2ECC6",
      symbol: "PT-syrupUSDC-29JAN2026",
    },
  },
  {
    id: "0x83c970dd4cad83be2b1e5ddd9224bc6868911bcbb01da1d42f340e1a2e2d5f87",
    name: "USDC / PT-thBILL-19FEB2026",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "915000000000000000",
    oracle: "0x3E0E1e5aef3ea576750AdED57b7Bf3a42161B6Cd",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x9b3924f9652cabf3Db48B7B4C92E474c571B3Ab4",
      symbol: "PT-thBILL-19FEB2026",
    },
  },
  {
    id: "0x836820ffec7a31b890eece79b5f1c06daab4059ff24e09e6db5a4a9bffa59d03",
    name: "sUSDe / MUX3LP-sUSDe-3",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "625000000000000000",
    oracle: "0xf62662775ffb74dCc1E2d1646E37C7cF74cf5745",
    loanToken: {
      address: "0x211Cc4DD073734dA055fbF44a2b4667d5E5fE5d2",
      symbol: "sUSDe",
    },
    collateralToken: {
      address: "0xAb0910755D99b420c51f48B6847733bB3fe19Af4",
      symbol: "MUX3LP-sUSDe-3",
    },
  },
  {
    id: "0x8258589d1964f42eff33ec8926312f4dcfe61664026e9cc3b52a5f6cc490744c",
    name: "unknown / MUX3LP-sUSDC-4",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "625000000000000000",
    oracle: "0x86a088154C0B876a426623E41C3e9e815c8300c8",
    loanToken: {
      address: "0xf8B3Fa720a9Cd8ABeeD5A81f11F80cD8f93E6B57",
      symbol: "unknown",
    },
    collateralToken: {
      address: "0xFfef0af5afB51574eEb4774A295823C1f596493F",
      symbol: "MUX3LP-sUSDC-4",
    },
  },
  {
    id: "0x8147c63f3f6f5a0825c84bf2cb11443c72b609fa39cf9a362e3d4dc2c5ca76c4",
    name: "USDC / PT-USDai-19FEB2026",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "915000000000000000",
    oracle: "0xC9166f013c79Cc473E97EC55da7f22f85D56b4d0",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x5B2C615E22272234AACF187632a0531cA1243279",
      symbol: "PT-USDai-19FEB2026",
    },
  },
  {
    id: "0x8097d1f6390ee915a9e053d8d03a308d8acba090a8678714bc5c13bd882f78a1",
    name: "USDC / WBTC",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0xEDcAE878827fc68B9bC9c700CA17c20F811b1612",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f",
      symbol: "WBTC",
    },
  },
  {
    id: "0x8011beebfbc91832b0341639d3628764da458fe29a482a42880768db143a50a8",
    name: "USD₮0 / syrupUSDC",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "915000000000000000",
    oracle: "0xBb81e2Cbc00e25827B9F91526FA38fD0d1523Ff8",
    loanToken: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
    collateralToken: {
      address: "0x41CA7586cC1311807B4605fBB748a3B8862b42b5",
      symbol: "syrupUSDC",
    },
  },
  {
    id: "0x7e7c08f2d8bb6821408ac6b4e2f322d73ba1fb8ce20b3b65087f440ef3b2f8f1",
    name: "USDC / sUSDe",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "915000000000000000",
    oracle: "0xdEb68dd2a482acEd6b8C8f828F4d35f245943B72",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x211Cc4DD073734dA055fbF44a2b4667d5E5fE5d2",
      symbol: "sUSDe",
    },
  },
  {
    id: "0x7d4799e15dcaad9da49ab8edf46d647db2da2ff419db52e8ec0984d0c49e8b9b",
    name: "USDC / PT-USDai-19FEB2026",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "915000000000000000",
    oracle: "0x838f9a104Df1B2F5b35FFd7cf84827CC82eE8DE9",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x5B2C615E22272234AACF187632a0531cA1243279",
      symbol: "PT-USDai-19FEB2026",
    },
  },
  {
    id: "0x7d14980617f8b0904485a1bd1a3c6038b4627fb2f2f9feb767d240989dbf9b5c",
    name: "USDe / USDe",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "915000000000000000",
    oracle: "0x5C448F1DDf01741905c47706CF9cF11a31F0Df7f",
    loanToken: {
      address: "0x5d3a1Ff2b6BAb83b63cd9AD0787074081a52ef34",
      symbol: "USDe",
    },
    collateralToken: {
      address: "0x5d3a1Ff2b6BAb83b63cd9AD0787074081a52ef34",
      symbol: "USDe",
    },
  },
  {
    id: "0x7c03103c24ccfa9188bf41a8d44423cf5492645805eb1d23d9f862717d3fe5ab",
    name: "USDC / xUSD",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "915000000000000000",
    oracle: "0x14A7F156062D35861a285c7A7F5662964c2fe155",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x6eAf19b2FC24552925dB245F9Ff613157a7dbb4C",
      symbol: "xUSD",
    },
  },
  {
    id: "0x7a57e376b05b31a1a60ba8d0ccea9b0733c9a2e15f3d5df79cd2eb3c9244ee9a",
    name: "MYRC / USDC",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0x7B0345FE59184FDD7A224E17Fe6FF316B699AEb5",
    loanToken: {
      address: "0x3eD03E95DD894235090B3d4A49E0C3239EDcE59e",
      symbol: "MYRC",
    },
    collateralToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x77fe2f7c2dd6f4da6bc5f445b06052ff8df55cb70cfce9afc16ec3c69a5fd3a3",
    name: "USDC / sUSDS",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "945000000000000000",
    oracle: "0x52CC7c3b27bb61D0a83785B5344acC919F8f7124",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xdDb46999F8891663a8F2828d25298f70416d7610",
      symbol: "sUSDS",
    },
  },
  {
    id: "0x7717f1e04510390518811b3133ea47c298094ddd1d806ed8f8867d88c727bad7",
    name: "USDC / PT-sUSDai-19FEB2026",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0x7678125b59a0a5365D673D874e807db8F2BaE2C0",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x1BF1311FCF914A69Dd5805C9B06b72F80539cB3f",
      symbol: "PT-sUSDai-19FEB2026",
    },
  },
  {
    id: "0x729e4ab1f1613a55f4dc6444cb073a2f9ba4c402f8c59e93e1d725f9ce45f23a",
    name: "USDC / PT-USDe-11DEC2025",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "915000000000000000",
    oracle: "0xEBd3b258d51C39e7f6EC820FF060003c20686128",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xf9921bc1837A97b8F853C83521122c3FBF3f365F",
      symbol: "PT-USDe-11DEC2025",
    },
  },
  {
    id: "0x71c2954e00c8f72864600c9d1d1cd70fa15202c4294cd938d80add3be2eced26",
    name: "USDC / sUSDai",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "915000000000000000",
    oracle: "0x8Db25aFE02C20783C7D4b52C738f8a560d53cdf9",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x0B2b2B2076d95dda7817e785989fE353fe955ef9",
      symbol: "sUSDai",
    },
  },
  {
    id: "0x711485986da61ecc5c778e69346866f9d2ad5e09c5e9a4f61557b8e9724b0943",
    name: "WETH / ezETH",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "945000000000000000",
    oracle: "0xE468929f1E6F065926c9C88E1E4Fd2a20005275e",
    loanToken: {
      address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x2416092f143378750bb29b79eD961ab195CcEea5",
      symbol: "ezETH",
    },
  },
  {
    id: "0x6d820ec8ab3decb97e74319a266131ab825d74dac44a7a1ca9e01af61e6a25de",
    name: "sUSDe / MUX3LP-sUSDe-1",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "625000000000000000",
    oracle: "0xa36BdEEae560047E89D88C1fb0d57d2644da2170",
    loanToken: {
      address: "0x211Cc4DD073734dA055fbF44a2b4667d5E5fE5d2",
      symbol: "sUSDe",
    },
    collateralToken: {
      address: "0xA1082BDFC6f21cD71073FFeE2823139D67878aaE",
      symbol: "MUX3LP-sUSDe-1",
    },
  },
  {
    id: "0x6c831dcc45a7c0af00b751da651bd874b96653c587615d11aafade7b357c4b43",
    name: "USDC / PT-thBILL-19FEB2026",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "915000000000000000",
    oracle: "0xb623285330A61203A248dD9c9301fEC120aaAF7b",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x9b3924f9652cabf3Db48B7B4C92E474c571B3Ab4",
      symbol: "PT-thBILL-19FEB2026",
    },
  },
  {
    id: "0x6c0dd00c4107f67df32fd79abfb8092e0b0ba17f90f825479cbd8ae3c09cabc5",
    name: "USDC / MXNB",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0x07d01ecdC769A2C01D64F1213Fc483e37CaB27A1",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xF197FFC28c23E0309B5559e7a166f2c6164C80aA",
      symbol: "MXNB",
    },
  },
  {
    id: "0x6a2b0c23c79dde84628314d21797f7bd5b06ae36e6bde6924ece64ef4821d2df",
    name: "USDC / PT-sUSDai-19FEB2026",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0x8cfaE2444E6BF89988D017A3140B2F6c3e704Fd1",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x1BF1311FCF914A69Dd5805C9B06b72F80539cB3f",
      symbol: "PT-sUSDai-19FEB2026",
    },
  },
  {
    id: "0x696bd807cdc63dd2aeb3c043f11401dbe030191433ced4f26a29604445fba1e8",
    name: "USD₮0 / WETH",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0x52ef6B1A37922FAD8Be2519Bb980d0B584200430",
    loanToken: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
    collateralToken: {
      address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
      symbol: "WETH",
    },
  },
  {
    id: "0x678b525f162b499b17d8fd71f3129bd3a5a10d4c728e6af02ee7c644ae262d01",
    name: "USDC / RLP",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "915000000000000000",
    oracle: "0x2d8380D2E2DBE516049fA2c4CB2EC48C418d249C",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x35E5dB674D8e93a03d814FA0ADa70731efe8a4b9",
      symbol: "RLP",
    },
  },
  {
    id: "0x660547e9ec397830795f76d7242254fba2a79b30fbc8886f849c9e159a5d8316",
    name: "sUSDe / MUX3LP-sUSDe-1",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "625000000000000000",
    oracle: "0xac22A3BB7edbe5769a467682AE68F3CAdE5c39a7",
    loanToken: {
      address: "0x211Cc4DD073734dA055fbF44a2b4667d5E5fE5d2",
      symbol: "sUSDe",
    },
    collateralToken: {
      address: "0xA1082BDFC6f21cD71073FFeE2823139D67878aaE",
      symbol: "MUX3LP-sUSDe-1",
    },
  },
  {
    id: "0x65d2c84dd59c43f555e62fb1959ba0cab4cc57e244d7f0879dd8f716ed23900a",
    name: "USD₮0 / stUSD",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "965000000000000000",
    oracle: "0x527Df15e68fA2c2da381aA3536F1AC99ad4cbC18",
    loanToken: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
    collateralToken: {
      address: "0x0022228a2cc5E7eF0274A7Baa600d44da5aB5776",
      symbol: "stUSD",
    },
  },
  {
    id: "0x659a40016cd270322d10e847c0361017f2513788d68537f98c7bb86e2130701c",
    name: "USDC / USDe",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "945000000000000000",
    oracle: "0xA3DD2ac880F05F099782e988a4868e347553d43D",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x5d3a1Ff2b6BAb83b63cd9AD0787074081a52ef34",
      symbol: "USDe",
    },
  },
  {
    id: "0x64f17de292978a8e9750a80af6db132061f20d2d1a03a1701c4a156da83859b5",
    name: "USD₮0 / MYRC",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0x276071DFf0a25d8dC5Da0E97ef7671f1A6128F59",
    loanToken: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
    collateralToken: {
      address: "0x3eD03E95DD894235090B3d4A49E0C3239EDcE59e",
      symbol: "MYRC",
    },
  },
  {
    id: "0x5dd281933e74e576825deda2f28764f1ad3818faa485cbefc808bef0fc1518e5",
    name: "USDC / GVLT",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "625000000000000000",
    oracle: "0x1104D3cd2cfa891964eF88BDE9F5d1DBe4947101",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xF24e1f3a17200a7C8ff8F61BD7a65745AD42D8dd",
      symbol: "GVLT",
    },
  },
  {
    id: "0x5bf9c5869328b1f3201f41d45b740afe2ca13f623282957d8c84ec84b61ae793",
    name: "sUSDe / MUX3LP-sUSDe-4",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "625000000000000000",
    oracle: "0x115F020eBE6d9755A1e57A22146A739B46A13553",
    loanToken: {
      address: "0x211Cc4DD073734dA055fbF44a2b4667d5E5fE5d2",
      symbol: "sUSDe",
    },
    collateralToken: {
      address: "0x3d0572808510C293Bc5C9C42033Dd471266D4b3A",
      symbol: "MUX3LP-sUSDe-4",
    },
  },
  {
    id: "0x5ae03ec9af76f2485413ee5c1109eb14760b47e9049c7f3db868d9ef659ef473",
    name: "USDC / TART",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "625000000000000000",
    oracle: "0xf2Fc7311345C3157949bC21b30805F94d539BC8e",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xaf7358D7f5583f0655b454ebC0BCc54d90fe8ecd",
      symbol: "TART",
    },
  },
  {
    id: "0x59685fafa04ed3043e71a1000c91fa0eb5b1a490e3bd38f9eb9039f25eb7093f",
    name: "USDC / twVSDT",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "770000000000000000",
    oracle: "0x924098A96F5b01c6011469B2A61E69965d5D4B39",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x13310ADB7137CeF67B62EBD7A8B0BB3bdC7A9709",
      symbol: "twVSDT",
    },
  },
  {
    id: "0x5956f04c24a38b41ac48f63f972cbcfa24f98497f8d68e404942cee4e2f8c793",
    name: "MYRC / WETH",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0x727562f5d3cB62Ad2244eD9B6777d9CCED269816",
    loanToken: {
      address: "0x3eD03E95DD894235090B3d4A49E0C3239EDcE59e",
      symbol: "MYRC",
    },
    collateralToken: {
      address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
      symbol: "WETH",
    },
  },
  {
    id: "0x59512c91acf570efcc7543578552c8598a26345a5d1e3a4df1b5b400cd79cee3",
    name: "USDC / bbqUSDT0",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "965000000000000000",
    oracle: "0xb7b324E7645A5526FAb05310A8E95303Af8dcF29",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xbeeff77CE5C059445714E6A3490E273fE7F2492F",
      symbol: "bbqUSDT0",
    },
  },
  {
    id: "0x58df3ad9cf719b1ca97365db634a11b770785517f409ecbe85eefdb34803de1f",
    name: "USDC / PT-sUSDai-20NOV2025",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0xC3C61Dc5fC21609CEA20B86829C3ef50eEefB98B",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x936F210d277bf489A3211CeF9AB4BC47a7B69C96",
      symbol: "PT-sUSDai-20NOV2025",
    },
  },
  {
    id: "0x582c92d5ea0ab48eba3a1ee88c8884e34f7fc61c57fb821f3f6d9e474574c6e3",
    name: "USDC / wstUSR",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "915000000000000000",
    oracle: "0x8d12430AD8C6875B351DC0b626c944C38b8f2D4c",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x66CFbD79257dC5217903A36293120282548E2254",
      symbol: "wstUSR",
    },
  },
  {
    id: "0x5827b9f542c9a9ceffcaeae8fe5fd46a5a6aeb44b705fa4015d80e87e66d03ab",
    name: "USDC / ARB",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "945000000000000000",
    oracle: "0xAB70fA36D764fe4c8ceD3d10611259BA9A35FC7D",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x912CE59144191C1204E64559FE8253a0e49E6548",
      symbol: "ARB",
    },
  },
  {
    id: "0x57459ec5b43ed4920b658ce3a68293f1d7e26b1135069750fbf881d60364708d",
    name: "USDC / TBUND",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "625000000000000000",
    oracle: "0x1D448CfB01448f1d9Dc4bEf55118046542EB591E",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xc923e4D60E401C10BA4a7199418b3BD22b118400",
      symbol: "TBUND",
    },
  },
  {
    id: "0x571cb3ac535d61d92026c071ef1df4794d0bbbe1755f916ff640746f81b52af4",
    name: "USD₮0 / syrupUSDC",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "915000000000000000",
    oracle: "0x8ceD7944c38A635146F02b1305a4697761Fe6D7B",
    loanToken: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
    collateralToken: {
      address: "0x41CA7586cC1311807B4605fBB748a3B8862b42b5",
      symbol: "syrupUSDC",
    },
  },
  {
    id: "0x551dbcdcceaf9322986e0cddde993d49840522a9532dc441359acd98af8badff",
    name: "USDC / thBILL",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "945000000000000000",
    oracle: "0x8e66f244F05277aAE16E1B5a586d742df932f157",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xfDD22Ce6D1F66bc0Ec89b20BF16CcB6670F55A5a",
      symbol: "thBILL",
    },
  },
  {
    id: "0x5425a6c02628d3ae174cf3f7ce0abf59cd5b83853bcc9e304f73395306be6fda",
    name: "MYRC / WBTC",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0x44FE193191B83CDE9675d25Ca6eF9e551D9018DA",
    loanToken: {
      address: "0x3eD03E95DD894235090B3d4A49E0C3239EDcE59e",
      symbol: "MYRC",
    },
    collateralToken: {
      address: "0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f",
      symbol: "WBTC",
    },
  },
  {
    id: "0x52f4d5038749565658a51f43d214e811c328c00c8b58c544accfb8924e8be8f8",
    name: "USDC / PT-sUSDai-20NOV2025",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0x68E07c01e5a21f11B940B5f751483deE3D502645",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x936F210d277bf489A3211CeF9AB4BC47a7B69C96",
      symbol: "PT-sUSDai-20NOV2025",
    },
  },
  {
    id: "0x529103b14a629f848bae2aad527fdb1ba3a20f0d1c5ed210238aa314112ea93d",
    name: "USDC / bbqUSDT0",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "965000000000000000",
    oracle: "0x389099110577eDEc687aAe8429D3d8fD861c90e7",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4739E2c293bDCD835829aA7c5d7fBdee93565D1a",
      symbol: "bbqUSDT0",
    },
  },
  {
    id: "0x50d1b741a63204ce27bdf17e5a9300800c350ecb9278d92d2292a5713ea227e6",
    name: "USDC / PT-sUSDai-18JUN2026",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0xfBd704607e27960BEe6dA5db68f142068215Cb7f",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x07bc5bD6cE9A17f0e7aa91E0Adbc9070dcB1d1dE",
      symbol: "PT-sUSDai-18JUN2026",
    },
  },
  {
    id: "0x4e0840dc8094be27e07689483023980b9df91a156d4bb876bedd8cc00f2498b9",
    name: "USD₮0 / PT-USDai-19FEB2026",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "915000000000000000",
    oracle: "0xB1F7a979706C9C9DbBD13E717590586c7D465E16",
    loanToken: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
    collateralToken: {
      address: "0x5B2C615E22272234AACF187632a0531cA1243279",
      symbol: "PT-USDai-19FEB2026",
    },
  },
  {
    id: "0x4d963c5f201cb1bb87fa044b80dff095684a79fe85c31433f6a5e4753c33a9d6",
    name: "USDC / PT-sUSDai-19FEB2026",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "945000000000000000",
    oracle: "0x3E0E1e5aef3ea576750AdED57b7Bf3a42161B6Cd",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x1BF1311FCF914A69Dd5805C9B06b72F80539cB3f",
      symbol: "PT-sUSDai-19FEB2026",
    },
  },
  {
    id: "0x4cd13184ac4f543040eb498202f006444985e26ff82bffc2dc05b8d22b97ee03",
    name: "USDC / wVSDT",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "770000000000000000",
    oracle: "0x924098A96F5b01c6011469B2A61E69965d5D4B39",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x63Fb9725B077Bafc32f2EBABCf04090901B79696",
      symbol: "wVSDT",
    },
  },
  {
    id: "0x4b9128a964529cb0bab20f470cbdc62fc69521dd2a3665671cb1c1d1aeb108b2",
    name: "unknown / MUX3LP-sUSDC-3",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "625000000000000000",
    oracle: "0x6d316823Ae54Cd0d8C50224314F47A17bb4F91d8",
    loanToken: {
      address: "0xf8B3Fa720a9Cd8ABeeD5A81f11F80cD8f93E6B57",
      symbol: "unknown",
    },
    collateralToken: {
      address: "0xb7500963a76f844C17FBb5d1d914F509AD863Db1",
      symbol: "MUX3LP-sUSDC-3",
    },
  },
  {
    id: "0x4af2748d71ac26350afde58339feffd84e03c93aaa69cba786b8dacdc9c0f374",
    name: "WETH / VSDT",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "625000000000000000",
    oracle: "0x0000000000000000000000000000000000000000",
    loanToken: {
      address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x8951D7D0E72349eA302928c853dD808A7ea1Eb06",
      symbol: "VSDT",
    },
  },
  {
    id: "0x474f52ca895319a8f52f982e2c8c0b3b75eba8a707ce8183ee5bad5990b05b05",
    name: "sUSDe / MUX3LP-sUSDe-4",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "625000000000000000",
    oracle: "0x5374237b1a02bF1Baa999fC3F42d4b13e6e472CC",
    loanToken: {
      address: "0x211Cc4DD073734dA055fbF44a2b4667d5E5fE5d2",
      symbol: "sUSDe",
    },
    collateralToken: {
      address: "0x3d0572808510C293Bc5C9C42033Dd471266D4b3A",
      symbol: "MUX3LP-sUSDe-4",
    },
  },
  {
    id: "0x46559f810fda131eff09df35a70429154d85a617b73b47bb5cd4bcfc91b95fb7",
    name: "USDC / USDe",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "915000000000000000",
    oracle: "0x9298874cF0996c0b681940D83ba59C1d3a8063b5",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x5d3a1Ff2b6BAb83b63cd9AD0787074081a52ef34",
      symbol: "USDe",
    },
  },
  {
    id: "0x43d98c93d4811126f21cec65bfd4514adc843b8a42824a8c857a8405ad8176e2",
    name: "USDC / PT-USDai-20NOV2025",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "915000000000000000",
    oracle: "0xf68a06c23dFafa2E8CC24062f2672a1a21b3fB69",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x8b4Ca42bB3B1d789859f106222CF7DC5EEd48CCb",
      symbol: "PT-USDai-20NOV2025",
    },
  },
  {
    id: "0x438daac4bb7c305f0bc853005897914c80b155da2437c40de99edb6f55696f3e",
    name: "USD₮0 / thBILL",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "915000000000000000",
    oracle: "0xa3787474F24F1ac3F335480E2Cb1dadbB192377A",
    loanToken: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
    collateralToken: {
      address: "0xfDD22Ce6D1F66bc0Ec89b20BF16CcB6670F55A5a",
      symbol: "thBILL",
    },
  },
  {
    id: "0x4136e811c8e953f35963d6522889913bc13c2fe98e8972844d22f3376f0af28f",
    name: "USD₮0 / sUSDS",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "945000000000000000",
    oracle: "0x52CC7c3b27bb61D0a83785B5344acC919F8f7124",
    loanToken: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
    collateralToken: {
      address: "0xdDb46999F8891663a8F2828d25298f70416d7610",
      symbol: "sUSDS",
    },
  },
  {
    id: "0x3e077841d6e3fcdd509fdf7430dec03618d3fd66734cdf9825fc677da8985ba6",
    name: "WETH / wstETH",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "945000000000000000",
    oracle: "0x70dCd188B6444fefFb772b1d3273D8f2767556FE",
    loanToken: {
      address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x5979D7b546E38E414F7E9822514be443A4800529",
      symbol: "wstETH",
    },
  },
  {
    id: "0x37c81f9b0484df44664f976e6cd12adb9008325bfce5eb662486c8b75f5afdb8",
    name: "sUSDC / MUX3LP-sUSDC-4",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "625000000000000000",
    oracle: "0x86a088154C0B876a426623E41C3e9e815c8300c8",
    loanToken: {
      address: "0x940098b108fB7D0a7E374f6eDED7760787464609",
      symbol: "sUSDC",
    },
    collateralToken: {
      address: "0xFfef0af5afB51574eEb4774A295823C1f596493F",
      symbol: "MUX3LP-sUSDC-4",
    },
  },
  {
    id: "0x35f0fef6845f40cc154f965125bd4f83f44c6a713ca0bc973d9283dbc548f86b",
    name: "USDC / gtWETH",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0xB53ae39BF6eF80CA8EB6E82e64F0Ac17eeD8bFB6",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xBD14bEa2eCECeCD5F32149B0f84BE7f7F446B964",
      symbol: "gtWETH",
    },
  },
  {
    id: "0x34ed3a66798913cdd4083c642b4ed2180769152289ea3f86d8c7a9eca08ea781",
    name: "USD₮0 / weETH",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0x4E49d73434a78866d217BE0B542CA868495CBc77",
    loanToken: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
    collateralToken: {
      address: "0x35751007a407ca6FEFfE80b3cB397736D2cf4dbe",
      symbol: "weETH",
    },
  },
  {
    id: "0x344f54c0341644a5a8c3f93300bf716031998b46b18b24e4dc67d92434ca6d36",
    name: "USDC / GVLT",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "625000000000000000",
    oracle: "0x1104D3cd2cfa891964eF88BDE9F5d1DBe4947101",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x57587e47A0aF9d1BB93c0D4B3df671B053aB4366",
      symbol: "GVLT",
    },
  },
  {
    id: "0x33e0c8ab132390822b07e5dc95033cf250c963153320b7ffca73220664da2ea0",
    name: "USDC / wstETH",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0x8e02a9b9Cc29d783b2fCB71C3a72651B591cae31",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x5979D7b546E38E414F7E9822514be443A4800529",
      symbol: "wstETH",
    },
  },
  {
    id: "0x32bb2cd1f1715f17d1f8a9b29fa7d369ca219a92247990e6a6568eb5d3da799d",
    name: "USD₮0 / wstETH",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "945000000000000000",
    oracle: "0x979e4C611e4da2776404fE9346D77e95B01BfD82",
    loanToken: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
    collateralToken: {
      address: "0x5979D7b546E38E414F7E9822514be443A4800529",
      symbol: "wstETH",
    },
  },
  {
    id: "0x311cd25d40380ba32f0fbbcb462f8eeeade7ced73003246fc2a02c23cc3f36b8",
    name: "USDC / bbqUSDT0",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "965000000000000000",
    oracle: "0x5259e2b5198BB9c03FeC459ca1E7B5CD88B4b90C",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xbeeff77CE5C059445714E6A3490E273fE7F2492F",
      symbol: "bbqUSDT0",
    },
  },
  {
    id: "0x30c505b1ce479157e1035bdc5de3d4c811cf3e427c31db0b81b5c27a09054e97",
    name: "USDC / PT-thBILL-27NOV2025",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "915000000000000000",
    oracle: "0x5D0C14978BAADf24b3c59FA5626ff1CD2f4b9a41",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x5a791652f3b140d357df072d355a98ab754877D1",
      symbol: "PT-thBILL-27NOV2025",
    },
  },
  {
    id: "0x2fda6e3bc727de52dccb98661449689c52ff3b84bcb180c65cb522513a921604",
    name: "sUSDe / MUX3LP-sUSDe-8",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "625000000000000000",
    oracle: "0xbBB6544f583CD5629ff7eEeabEcC1911860334a9",
    loanToken: {
      address: "0x211Cc4DD073734dA055fbF44a2b4667d5E5fE5d2",
      symbol: "sUSDe",
    },
    collateralToken: {
      address: "0x87f980bb419365DF5E665C8Af0a3996BE154873a",
      symbol: "MUX3LP-sUSDe-8",
    },
  },
  {
    id: "0x2bb105abab4c07e200f839976c57a42ebe8a1817cd6414df9f5af51bfc068c02",
    name: "sUSDC / MUX3LP-sUSDC-2",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "625000000000000000",
    oracle: "0xf961556026431E9704d179fC3e49a1c10751299d",
    loanToken: {
      address: "0x940098b108fB7D0a7E374f6eDED7760787464609",
      symbol: "sUSDC",
    },
    collateralToken: {
      address: "0x651B884f22FDA21090eF5326d8F78BD6DC9D2D65",
      symbol: "MUX3LP-sUSDC-2",
    },
  },
  {
    id: "0x2745844e5fdf921f31bae761e6095868fb689949a6fc8558ec9ec5471107b47f",
    name: "unknown / MUX3LP-sUSDC-1",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "625000000000000000",
    oracle: "0x1168e7bE6C5Aa56dFB757451fBc7Dc11020bFc68",
    loanToken: {
      address: "0xf8B3Fa720a9Cd8ABeeD5A81f11F80cD8f93E6B57",
      symbol: "unknown",
    },
    collateralToken: {
      address: "0x5513FD8d55133ECc0f5fF0bF768c100528132630",
      symbol: "MUX3LP-sUSDC-1",
    },
  },
  {
    id: "0x216bb60898e75fa9abc57c59ca0f6f4fcf6bc85667aea140177c61e1e11d7029",
    name: "USD₮0 / WBTC",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0xf4c5304736Abb917336F5Bc5BF729934FB07f8Fd",
    loanToken: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
    collateralToken: {
      address: "0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f",
      symbol: "WBTC",
    },
  },
  {
    id: "0x20d6d31380d97b152f6dceeebb339e0cf018a671c09796a33772e0b25c93ed78",
    name: "MYRC / WBTC",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0xC9c16a2DDC6889417C3EC29baaC608602DE4450d",
    loanToken: {
      address: "0x3eD03E95DD894235090B3d4A49E0C3239EDcE59e",
      symbol: "MYRC",
    },
    collateralToken: {
      address: "0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f",
      symbol: "WBTC",
    },
  },
  {
    id: "0x209fa1520640f664f59f7c1f955d52e8b81ead826edf439b48254d21d24b97a9",
    name: "USD₮0 / wstETH",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0x979e4C611e4da2776404fE9346D77e95B01BfD82",
    loanToken: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
    collateralToken: {
      address: "0x5979D7b546E38E414F7E9822514be443A4800529",
      symbol: "wstETH",
    },
  },
  {
    id: "0x1e4869e7087be6fb493599a2d86e93ccbd1a03fed4f3f22fb685c8030e36480d",
    name: "USDC / HYDRO",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "625000000000000000",
    oracle: "0x0A96cB06A7BaDc652D1816e087940644754d9BD6",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xD3bE2Ace01fDe553E7eAa42752cf7bb0EE7BD999",
      symbol: "HYDRO",
    },
  },
  {
    id: "0x1d11f2e7d5381ccbec21294a530e4241bb3e0bd9cb47db9a47d2bbba0ef58605",
    name: "USDC / PT-USDai-19FEB2026",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "915000000000000000",
    oracle: "0xa8B3F0451312e2D8Aa2BD0A1d4Fd674570007DFC",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x5B2C615E22272234AACF187632a0531cA1243279",
      symbol: "PT-USDai-19FEB2026",
    },
  },
  {
    id: "0x1d094624063756fc61aaf061c7da056aebe3b3ad0ae0395b22e00db6c074de7c",
    name: "USD₮0 / XAUt0",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "770000000000000000",
    oracle: "0xADE5f08073E1097242F8E73c51213438D214896E",
    loanToken: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
    collateralToken: {
      address: "0x40461291347e1eCbb09499F3371D3f17f10d7159",
      symbol: "XAUt0",
    },
  },
  {
    id: "0x1bd743ac66df5ce55ea90e8ada43ff9c804a0a2cc75be7e9c3d06816bb4bcab9",
    name: "USDC / PT-USDai-19FEB2026",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "915000000000000000",
    oracle: "0x15BA6721a08b4f98751e8B78CAA6f9aa167Dc672",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x5B2C615E22272234AACF187632a0531cA1243279",
      symbol: "PT-USDai-19FEB2026",
    },
  },
  {
    id: "0x1a926ab8add08dca634f8d6cecd8c866e166a4affc65801beda9f239d21b622a",
    name: "USDC / GM",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "770000000000000000",
    oracle: "0x9F73de91F895fD71282eE3176F1A52093E64B2a3",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x70d95587d40A2caf56bd97485aB3Eec10Bee6336",
      symbol: "GM",
    },
  },
  {
    id: "0x18ebc33fdd269d3982b0ed0ef1293a005af6f4fa423eb9d814a96a394fac0e91",
    name: "MYRC / USDC",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0xc350da53f5Cc810Cd03048F719aca232A3ec79A6",
    loanToken: {
      address: "0x3eD03E95DD894235090B3d4A49E0C3239EDcE59e",
      symbol: "MYRC",
    },
    collateralToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
  },
  {
    id: "0x16d08880afcfe1786c594b28809e3bccc2c6dc4a46a14e42ba30e2ebefe77f83",
    name: "USDC / PT-USDai-20NOV2025",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "915000000000000000",
    oracle: "0x480BA79A5193d5239f1788Aa7f02be8751b667fb",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x8b4Ca42bB3B1d789859f106222CF7DC5EEd48CCb",
      symbol: "PT-USDai-20NOV2025",
    },
  },
  {
    id: "0x14982da64b67967ef3a70c2f3b7d05518f7dd4ba98d850c40c46618c75059a64",
    name: "USDC / GLV [WETH-USDC]",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "770000000000000000",
    oracle: "0xaE6bd24bB966e07115a344d701718AE044eD1fD8",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x528A5bac7E746C9A509A1f4F6dF58A03d44279F9",
      symbol: "GLV [WETH-USDC]",
    },
  },
  {
    id: "0x139b594efa4f8792647e81cfdcd3ba3bf5ea64f9c68fdbb3320613de98df8434",
    name: "WETH / rETH",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "945000000000000000",
    oracle: "0xa23175b3066672F4C5e07c6Fd21913efEA74e6EF",
    loanToken: {
      address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xEC70Dcb4A1EFa46b8F2D97C310C9c4790ba5ffA8",
      symbol: "rETH",
    },
  },
  {
    id: "0x136d9ba9c773fecbfb20b69255fb10bf43a45cef865a92a15665b37046d702ab",
    name: "USDC / ARB",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "965000000000000000",
    oracle: "0x9D796335F4e5642711fE74049d66F4c18a8012e7",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x912CE59144191C1204E64559FE8253a0e49E6548",
      symbol: "ARB",
    },
  },
  {
    id: "0x11d3bca0d1a9af8bf2982ef802f2971cf86043df1b31a044cacb35a8048156c6",
    name: "USDC / wsrUSD",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "915000000000000000",
    oracle: "0x77bd2e0C9309FE3c4393e568Bc751AAaBf7306C3",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4809010926aec940b550D34a46A52739f996D75D",
      symbol: "wsrUSD",
    },
  },
  {
    id: "0x10cf65a6fb55ff1eaa273b025b481cd280f74dbd2998e77b07c58db4090e051f",
    name: "sUSDe / MUX3LP-sUSDe-6",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "625000000000000000",
    oracle: "0x6a945b36c479f5c0Eb49Be5788841754395DADB7",
    loanToken: {
      address: "0x211Cc4DD073734dA055fbF44a2b4667d5E5fE5d2",
      symbol: "sUSDe",
    },
    collateralToken: {
      address: "0xC432B2A5100C99ef12161Be5237B3a5Cfc3E8377",
      symbol: "MUX3LP-sUSDe-6",
    },
  },
  {
    id: "0x0fccf0a6bbcf39bab9f707663ee96dac5a4c4f7d8f8371d37efab6bbe0328baa",
    name: "sUSDC / MUX3LP-sUSDC-3",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "625000000000000000",
    oracle: "0x6d316823Ae54Cd0d8C50224314F47A17bb4F91d8",
    loanToken: {
      address: "0x940098b108fB7D0a7E374f6eDED7760787464609",
      symbol: "sUSDC",
    },
    collateralToken: {
      address: "0xb7500963a76f844C17FBb5d1d914F509AD863Db1",
      symbol: "MUX3LP-sUSDC-3",
    },
  },
  {
    id: "0x0eedc5ee101e262ed96d49d66ff7099b1b9d996ac8007b44a6925b2f8c0626ed",
    name: "USDC / sSuperUSD",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "915000000000000000",
    oracle: "0x393A33fc66C1C0742B0e65EE1C239Cf65D2aF3e4",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x139450C2dCeF827C9A2a0Bb1CB5506260940c9fd",
      symbol: "sSuperUSD",
    },
  },
  {
    id: "0x0e5b0847532fab47c99869dba77a0109b076c8e468b4e3a145a3d39dc89e9035",
    name: "USDC / GM",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "770000000000000000",
    oracle: "0x23D0B6Ff2931c0E84ecFae60b13c1eA7B9C8a3DE",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x47c031236e19d024b42f8AE6780E44A573170703",
      symbol: "GM",
    },
  },
  {
    id: "0x0e08ee683627c30374569dd44a3251f0757ac491c61fd91a97661aa26743f0dd",
    name: "USDC / VSDT",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "770000000000000000",
    oracle: "0x0000000000000000000000000000000000000000",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x8951D7D0E72349eA302928c853dD808A7ea1Eb06",
      symbol: "VSDT",
    },
  },
  {
    id: "0x0d214085e75fac4a130bf39ea0def223e122c97347844e51091586db9f166af1",
    name: "PERt / USD₮0",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "770000000000000000",
    oracle: "0x99d6d7a38718D37d4573F4D0EabE22fCb93fDcd3",
    loanToken: {
      address: "0x899438713f62B04d6CD8e8709986F7256fB6E3d9",
      symbol: "PERt",
    },
    collateralToken: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
  },
  {
    id: "0x0ca9acd05baee2a6cb00d20d95b32269bf6956808230687f381a1a3e473b694f",
    name: "MYRC / WBTC",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0x77eB2b3750808928b5E0631705be6A4a4DAD3366",
    loanToken: {
      address: "0x3eD03E95DD894235090B3d4A49E0C3239EDcE59e",
      symbol: "MYRC",
    },
    collateralToken: {
      address: "0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f",
      symbol: "WBTC",
    },
  },
  {
    id: "0x0946f2b58ae7f82edaeeead4f472aa51b0114085e3e5ab56d810ffd1604291ab",
    name: "PUSD / PGOLD",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "770000000000000000",
    oracle: "0xf1c29B93Da9D5Af8Df7b85C8dDAf56bA79FF2cb2",
    loanToken: {
      address: "0xC8Fb643D18F1e53698CFDa5c8Fdf0cdC03C1dBec",
      symbol: "PUSD",
    },
    collateralToken: {
      address: "0x3e76BB02286BFeAA89DD35f11253f2CbCE634F91",
      symbol: "PGOLD",
    },
  },
  {
    id: "0x090ff0cd57a258b342c870691a180bb79691e97b31ddda2b7cdd4b5a362c3cca",
    name: "USD₮0 / PT-USDai-19FEB2026",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "915000000000000000",
    oracle: "0x5E41400Ea3B718163cbA67f17AC9a5117468680E",
    loanToken: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
    collateralToken: {
      address: "0x5B2C615E22272234AACF187632a0531cA1243279",
      symbol: "PT-USDai-19FEB2026",
    },
  },
  {
    id: "0x06a5954e8222a1f4719934d370ac558b657c6a5321d6cae615127b6596d10d32",
    name: "USDC / wstUSR",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "915000000000000000",
    oracle: "0x5ad6Bbde9c8F78520cfBf13891eDeD12Dc63cF53",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x66CFbD79257dC5217903A36293120282548E2254",
      symbol: "wstUSR",
    },
  },
  {
    id: "0x04a8be22ce6670cb6c3f0a4012a6f9503a349b3096e0aff9c2f71c4c52b7c4cf",
    name: "sUSDe / MUX3LP-sUSDe-5",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "625000000000000000",
    oracle: "0x177e4D6E8B54A75C12670b2f4326CCdE289c4BA7",
    loanToken: {
      address: "0x211Cc4DD073734dA055fbF44a2b4667d5E5fE5d2",
      symbol: "sUSDe",
    },
    collateralToken: {
      address: "0x4aC33D0E24c9b4e51FcDDDd680534755a1d6A514",
      symbol: "MUX3LP-sUSDe-5",
    },
  },
  {
    id: "0x03ac8bc891fb338ebb0ea40cfc298e3577a93828ed3e77296f8573160dc3c9cc",
    name: "syrupUSDC / USDC",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0xF8722c901675C4F2F7824E256B8A6477b2c105FB",
    loanToken: {
      address: "0x41CA7586cC1311807B4605fBB748a3B8862b42b5",
      symbol: "syrupUSDC",
    },
    collateralToken: {
      address: "0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8",
      symbol: "USDC",
    },
  },
  {
    id: "0x02729deb2bdef3a866249341927d5a019552524d1e31f30fc6bf7ae3604555e2",
    name: "USD₮0 / PT-syrupUSDC-29JAN2026",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "915000000000000000",
    oracle: "0xF6B9271e8ffc8e8BbE753470c400477600300C03",
    loanToken: {
      address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
      symbol: "USD₮0",
    },
    collateralToken: {
      address: "0x1Ef58a7aF39883CC95c59a2c106b726C64c2ECC6",
      symbol: "PT-syrupUSDC-29JAN2026",
    },
  },
  {
    id: "0x021b4d7adb8e11c479136f390442f655382133b1acb5b078a86a8cebc7fa4f48",
    name: "USDC / WETH",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "860000000000000000",
    oracle: "0x639Fe6ab55C921f74e7fac1ee960C0B6293ba612",
    loanToken: {
      address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
      symbol: "WETH",
    },
  },
  {
    id: "0x005e0178220fd1db3d8b0f757994fa61fb317b0aebb0d37509650b6da5c092a6",
    name: "sUSDe / MUX3LP-sUSDe-2",
    irm: "0x66F30587FB8D4206918deb78ecA7d5eBbafD06DA",
    lltv: "625000000000000000",
    oracle: "0xD5a7Cd3ab58Fe108aeac3F7c45357D7342a829F1",
    loanToken: {
      address: "0x211Cc4DD073734dA055fbF44a2b4667d5E5fE5d2",
      symbol: "sUSDe",
    },
    collateralToken: {
      address: "0xd85D0bCE8Ff396EA1198996a21f96Db2feB8e943",
      symbol: "MUX3LP-sUSDe-2",
    },
  },
] as const
